<template>
  <v-alert
    text
    color="grey darken-1"
    border="left"
    style="font-size: 1em;"
    class="pl-6"
    v-bind="$attrs"
  >
    <p>{{ trans('emailSettings.availableTemplateVariables') }}:</p>
    <table></table>
    <tr
      v-for="(placeholder, i) in placeholders"
      :key="'placeholder' + i"
    >
      <td class="pr-4"><span class="font-weight-bold">{{ '{' + placeholder.key + '}' }}</span></td>
      <td>{{ placeholder.name }}</td>
    </tr>
  </v-alert>
</template>

<script>
import {LocaleUtils} from '@/utils/locale-utils';

export default {
  name: 'TemplatePlaceholderList',
  mixins: [
    LocaleUtils
  ],
  props: {
    placeholders: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
